const postagetypes = [
  { name: 'Brev', value: 'letter', illustration: 'letterbox-reply-letter-plants' },
  { name: 'Paket', value: 'parcel', illustration: 'tracking' },
];

const deliveryscopes = {
  letter: [
    { name: 'Sweden', value: 'sweden', illustration: 'letterboxes' },
    { name: 'Abroad', value: 'abroad', illustration: 'character-box-letters-globe' },
  ],
  parcel: [
    { name: 'Sweden', value: 'sweden', illustration: 'letterboxes' },
    { name: 'Within Europe', value: 'withineurope', illustration: 'character-box-letters-globe' },
    { name: 'Outside Europe', value: 'outsideeurope', illustration: 'discover' },
  ],
};

const weights = {
  letter: [
    { name: '50g', abbreviation: 'g', value: 50 },
    { name: '100g', abbreviation: 'g', value: 100 },
    { name: '250g', abbreviation: 'g', value: 250 },
    { name: '500g', abbreviation: 'g', value: 500 },
    { name: '1kg', abbreviation: 'kg', value: 1 },
    { name: '2kg', abbreviation: 'kg', value: 2 },
  ],
  parcel: [
    { name: '1kg', abbreviation: 'kg', value: 1 },
    { name: '2kg', abbreviation: 'kg', value: 2 },
    { name: '3kg', abbreviation: 'kg', value: 3 },
    { name: '4kg', abbreviation: 'kg', value: 4 },
    { name: '5kg', abbreviation: 'kg', value: 5 },
    { name: '6kg', abbreviation: 'kg', value: 6 },
    { name: '7Kg', abbreviation: 'kg', value: 7 },
    { name: '8kg', abbreviation: 'kg', value: 8 },
    { name: '9kg', abbreviation: 'kg', value: 9 },
    { name: '10kg', abbreviation: 'kg', value: 10 },
    { name: '11kg', abbreviation: 'kg', value: 11 },
    { name: '12kg', abbreviation: 'kg', value: 12 },
    { name: '13kg', abbreviation: 'kg', value: 13 },
    { name: '14kg', abbreviation: 'kg', value: 14 },
    { name: '15kg', abbreviation: 'kg', value: 15 },
    { name: '16kg', abbreviation: 'kg', value: 16 },
    { name: '17kg', abbreviation: 'kg', value: 17 },
    { name: '18kg', abbreviation: 'kg', value: 18 },
    { name: '20kg', abbreviation: 'kg', value: 20 },
  ],
};

export { postagetypes, weights, deliveryscopes };
